import styled from 'vue-styled-components';
import { FONTS } from '@shared/constants';

export const ChartContainer = styled.div`
  height: 480px;
  margin-bottom: 25px;
`;

export const ChartTitle = styled.h2`
  padding: 20px 0;
`;

export const FilterList = styled.ul`
  list-style: none;
  padding: 0;
`;

export const FilterListItem = styled.li`
  display: inline-block;
  margin-right: 20px;
  font-family: ${FONTS.KNOCKOUT_50_FONT};

  &:before {
    content: '';
    display: inline-block;
    width: 12px;
    height: 12px;
    background-color: currentColor;
    border-radius: 99px;
    margin-right: 5px;
  }
`;

export const TreemapParent = styled.div`
  box-sizing: border-box;
  position: absolute;
  overflow: hidden;
  // box-shadow: 0 1px 2px 0 rgb(229, 229, 229);
  pointer-events: none;
`;

export const TreemapParentLabel = styled.div`
  padding: 4%;
  line-height: 1.2em;
  color: #fff;
  position: absolute;
  font-weight: bold;
  font-family: ${FONTS.KNOCKOUT_32_FONT};
`;

export const TreemapNode = styled.div`
  box-sizing: border-box;
  position: absolute;
  overflow: hidden;
  transition: transform 400ms ease-in-out, opacity 400ms ease-in-out, outline 400ms ease-in-out, box-shadow 400ms ease-in-out;
  opacity: 1;
  outline: 1px solid transparent;
`;
